// extracted by mini-css-extract-plugin
export default {"button":"TestsTable-module__button__zLNkI","selectForInterviewButton":"TestsTable-module__selectForInterviewButton__VdQTa","actionsCell":"TestsTable-module__actionsCell__sM01l"};